module.exports = __webpack_public_path__ + "img/cri.7b4ebd50.svg";